import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CustomValidators } from '../../validators/custom-validators.validators';
import { FormulaireCoordonneesBancaires } from './formulaire-coordonnees-bancaires.model';

export class FormulaireBancaireBuilder {
  static build(): FormGroup<FormulaireCoordonneesBancaires> {
    return new FormGroup<FormulaireCoordonneesBancaires>({
      utiliserMemeAdresse: new FormControl<boolean | null>(null, [Validators.required]),
      numeroCivique: new FormControl<string>('', [Validators.required]),
      rue: new FormControl<string>('', [Validators.required]),
      appartement: new FormControl<string>(''),
      ville: new FormControl<string>('', [Validators.required]),
      province: new FormControl<string>('', [Validators.required]),
      codePostal: new FormControl<string>('', [Validators.required]),
      codePays: new FormControl<string>('', [Validators.required]),
      courriel: new FormControl<string>('', [
        Validators.minLength(6),
        Validators.maxLength(64),
        CustomValidators.texteNonBlanc,
        CustomValidators.courrielBancaireValide,
      ]),
      telephone: new FormControl<string>('', [Validators.maxLength(12)]),
      dateChangement: new FormControl<string>('', [Validators.required]),
    });
  }
}
